<template>
  <div class="ca-suscripciones">
    <header class="ca-cabecera">
      <div>
        <h1 class="ca-titulo">Suscripciones por empresa</h1>
        <p class="ca-subtitulo">Asigna planes a empresas y administra el historial de suscripciones.</p>
      </div>
    </header>

    <!-- Selector de empresa -->
    <div class="ca-card ca-card--filtro">
      <label>Empresa
        <select v-model="empresaIdSeleccionada" class="ca-input" @change="cargarSuscripciones">
          <option :value="null">Selecciona una empresa</option>
          <option v-for="e in empresas" :key="e.id" :value="e.id">{{ e.razon_social }} ({{ e.ruc }})</option>
        </select>
      </label>
    </div>

    <div v-if="empresaIdSeleccionada">
      <div class="ca-acciones-fila">
        <button class="ca-boton ca-boton--primario" @click="abrirNuevaSuscripcion">
          <i class="bi bi-plus-lg"></i> Nueva suscripcion
        </button>
      </div>

      <div v-if="cargando" class="ca-info">Cargando...</div>
      <div v-else-if="!suscripciones.length" class="ca-info">Esta empresa no tiene suscripciones registradas.</div>

      <table v-else class="ca-tabla">
        <thead>
          <tr>
            <th>Plan</th><th>Inicio</th><th>Fin</th><th>Estado</th><th>Creado</th><th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="s in suscripciones" :key="s.id">
            <td><strong>{{ s.plan_nombre }}</strong> <span class="ca-codigo">{{ s.plan_codigo }}</span></td>
            <td>{{ s.fecha_inicio }}</td>
            <td>{{ s.fecha_fin }}</td>
            <td><span :class="['ca-badge', claseEstado(s.estado)]">{{ s.estado }}</span></td>
            <td>{{ s.creado_en }}</td>
            <td class="ca-tabla__acciones">
              <select :value="s.estado" class="ca-input ca-input--inline" @change="cambiarEstado(s, $event.target.value)">
                <option value="activa">activa</option>
                <option value="en_gracia">en_gracia</option>
                <option value="vencida">vencida</option>
                <option value="cancelada">cancelada</option>
              </select>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Modal nueva suscripcion -->
    <div v-if="modalNueva" class="ca-modal-fondo" @click.self="modalNueva = null">
      <div class="ca-modal">
        <h2>Nueva suscripcion</h2>
        <label>Plan
          <select v-model.number="modalNueva.plan_id" class="ca-input">
            <option :value="null">Selecciona un plan</option>
            <option v-for="p in planes" :key="p.id" :value="p.id">{{ p.nombre }} ({{ p.periodo }} - ${{ Number(p.costo).toFixed(2) }})</option>
          </select>
        </label>
        <div class="ca-grid-2">
          <label>Fecha inicio<input v-model="modalNueva.fecha_inicio" type="date" class="ca-input"/></label>
          <label>Fecha fin<input v-model="modalNueva.fecha_fin" type="date" class="ca-input"/></label>
        </div>
        <label>Estado
          <select v-model="modalNueva.estado" class="ca-input">
            <option value="activa">activa</option>
            <option value="en_gracia">en_gracia</option>
            <option value="vencida">vencida</option>
            <option value="cancelada">cancelada</option>
          </select>
        </label>
        <div class="ca-modal__acciones">
          <button class="ca-boton ca-boton--secundario" @click="modalNueva = null">Cancelar</button>
          <button class="ca-boton ca-boton--primario" @click="guardarSuscripcion" :disabled="guardando">Guardar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api'
import controlAcceso from '@/services/controlAccesoService'
import { notifySuccess, notifyError } from '@/services/notificationService'

export default {
  name: 'ControlAccesoSuscripciones',
  data() {
    return {
      empresas: [],
      planes: [],
      empresaIdSeleccionada: null,
      suscripciones: [],
      modalNueva: null,
      cargando: false,
      guardando: false,
    }
  },
  mounted() { this.cargarInicial() },
  methods: {
    async cargarInicial() {
      try {
        const [resEmp, resPla] = await Promise.all([
          api.get('/companies-register/subdominios'),
          controlAcceso.listarPlanes(),
        ])
        const data = resEmp?.data
        this.empresas = Array.isArray(data?.data) ? data.data : (Array.isArray(data) ? data : [])
        this.planes = resPla.data || []
      } catch (e) {
        notifyError('No se pudieron cargar empresas o planes.')
      }
    },
    async cargarSuscripciones() {
      if (!this.empresaIdSeleccionada) { this.suscripciones = []; return }
      this.cargando = true
      try {
        const res = await controlAcceso.listarSuscripcionesEmpresa(this.empresaIdSeleccionada)
        this.suscripciones = res.data || []
      } catch (e) {
        notifyError('No se pudieron cargar las suscripciones.')
      } finally { this.cargando = false }
    },
    abrirNuevaSuscripcion() {
      const hoy = new Date().toISOString().slice(0, 10)
      const enUnMes = new Date(Date.now() + 30 * 86400000).toISOString().slice(0, 10)
      this.modalNueva = {
        plan_id: null,
        fecha_inicio: hoy,
        fecha_fin: enUnMes,
        estado: 'activa',
      }
    },
    async guardarSuscripcion() {
      const m = this.modalNueva
      if (!m.plan_id) { notifyError('Selecciona un plan.'); return }
      if (!m.fecha_inicio || !m.fecha_fin) { notifyError('Fechas obligatorias.'); return }
      this.guardando = true
      try {
        await controlAcceso.crearSuscripcionEmpresa(this.empresaIdSeleccionada, m)
        notifySuccess('Suscripcion creada.')
        this.modalNueva = null
        await this.cargarSuscripciones()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al crear la suscripcion.')
      } finally { this.guardando = false }
    },
    async cambiarEstado(s, nuevoEstado) {
      if (nuevoEstado === s.estado) return
      try {
        await controlAcceso.cambiarEstadoSuscripcion(s.id, nuevoEstado)
        notifySuccess('Estado actualizado.')
        await this.cargarSuscripciones()
      } catch (e) {
        notifyError(e?.response?.data?.error || 'Error al cambiar estado.')
      }
    },
    claseEstado(estado) {
      switch (estado) {
        case 'activa':     return 'ca-badge--exito'
        case 'en_gracia':  return 'ca-badge--advertencia'
        case 'vencida':    return 'ca-badge--peligro'
        case 'cancelada':  return 'ca-badge--neutro'
        default:           return 'ca-badge--neutro'
      }
    },
  },
}
</script>

<style scoped>
.ca-suscripciones { color: var(--text-primary); }
.ca-cabecera { display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 18px; gap: 16px; }
.ca-titulo { font-size: 1.4rem; margin: 0; }
.ca-subtitulo { margin: 4px 0 0; color: var(--text-secondary); font-size: 0.9rem; }

.ca-card {
  background: var(--secondary-bg-main);
  border: 1px solid var(--border-main);
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 14px;
  box-shadow: var(--shadow-sm);
}
.ca-card--filtro label { display: block; font-size: 0.85rem; color: var(--text-secondary); margin: 0; }

.ca-acciones-fila { display: flex; justify-content: flex-end; margin-bottom: 12px; }

.ca-tabla { width: 100%; border-collapse: collapse; font-size: 0.88rem; background: var(--secondary-bg-main); border: 1px solid var(--border-main); border-radius: 12px; overflow: hidden; }
.ca-tabla th, .ca-tabla td { padding: 10px 12px; border-bottom: 1px solid var(--border-main); text-align: left; }
.ca-tabla th { font-weight: 600; color: var(--text-secondary); background: var(--bg-main); }
.ca-tabla tbody tr:last-child td { border-bottom: 0; }
.ca-tabla__acciones { width: 160px; }

.ca-info { padding: 14px; color: var(--text-secondary); }
.ca-codigo {
  display: inline-block;
  padding: 1px 8px;
  border-radius: 6px;
  background: var(--bg-main);
  color: var(--text-secondary);
  font-size: 0.74rem;
  font-family: ui-monospace, monospace;
  margin-left: 6px;
}

.ca-badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  text-transform: lowercase;
}
.ca-badge--exito       { background: color-mix(in srgb, var(--accent-success) 18%, transparent); color: var(--accent-success); }
.ca-badge--advertencia { background: color-mix(in srgb, var(--accent-warning) 18%, transparent); color: var(--accent-warning); }
.ca-badge--peligro     { background: color-mix(in srgb, var(--accent-danger) 18%, transparent);  color: var(--accent-danger); }
.ca-badge--neutro      { background: var(--bg-main); color: var(--text-muted); }

.ca-boton {
  border: 1px solid var(--border-main);
  background: var(--secondary-bg-main);
  color: var(--text-primary);
  border-radius: 8px;
  padding: 8px 14px;
  font-size: 0.88rem;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
.ca-boton:hover:not(:disabled) { background: var(--bg-main); }
.ca-boton:disabled { opacity: 0.6; cursor: not-allowed; }
.ca-boton--primario { background: var(--primary-main); border-color: var(--primary-main); color: #fff; }
.ca-boton--primario:hover:not(:disabled) { background: var(--primary-hover); border-color: var(--primary-hover); }
.ca-boton--secundario { background: transparent; }

.ca-modal-fondo { position: fixed; inset: 0; z-index: 2000; background: rgba(0,0,0,0.45); display: flex; align-items: center; justify-content: center; }
.ca-modal {
  background: var(--secondary-bg-main); color: var(--text-primary);
  border-radius: 12px; padding: 22px; min-width: 420px; max-width: 560px;
  border: 1px solid var(--border-main); box-shadow: var(--shadow-md);
}
.ca-modal h2 { font-size: 1.1rem; margin: 0 0 16px; }
.ca-modal label { display: block; margin-bottom: 10px; font-size: 0.85rem; color: var(--text-secondary); }
.ca-modal__acciones { display: flex; justify-content: flex-end; gap: 8px; margin-top: 14px; }

.ca-input {
  width: 100%;
  background: var(--bg-main);
  color: var(--text-primary);
  border: 1px solid var(--border-main);
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 0.92rem;
  margin-top: 4px;
}
.ca-input--inline { width: auto; padding: 4px 8px; font-size: 0.82rem; margin: 0; }
.ca-input:focus { outline: none; border-color: var(--border-focus); }
.ca-grid-2 { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
</style>
